import { styled } from "@mui/material/styles"

interface IRoleBannerProps {
	role: string
}

const Banner = styled("span")(() => ({
	fontSize: "12px",
	color: "#333",
	borderRadius: "10px",
	padding: "4px 8px",
	[`&.PAYDO_ADMIN`]: {
		backgroundColor: "#98bd0a",
		color: "#333",
		marginBottom: "0",
	},

	[`&.CORPORATE_OPERATOR`]: {
		backgroundColor: "#e8c600",
		color: "#222",
		marginBottom: "0",
		fontWeight: "600",
	},
	[`&.PAYDO_MANAGER`]: {
		backgroundColor: "#007a4d",
		color: "#FFF",
		marginBottom: "0",
	},
	[`&.PAYDO_USER`]: {
		backgroundColor: "#464646",
		color: "#FFF",
		marginBottom: "0",
	},
	[`&.CORPORATE_ADMIN`]: {
		backgroundColor: "#893de7",
		color: "#FFF",
		marginBottom: "0",
	},
	[`&.BANK_CORPORATE_ADMIN`]: {
		backgroundColor: "#5258e4",
		color: "#FFF",
		marginBottom: "0",
	},
	[`&.BANK_CORPORATE_AUTHORIZER`]: {
		backgroundColor: "#5258e4",
		color: "#FFF",
		marginBottom: "0",
	},
	[`&.BANK_AUTHORIZER`]: {
		backgroundColor: "#6b48e5",
		color: "#FFF",
		marginBottom: "0",
	},
	[`&.BANK_OPERATOR`]: {
		backgroundColor: "#0265dc",
		color: "#FFF",
		marginBottom: "0",
	},
	[`&.BANK_ADMIN`]: {
		backgroundColor: "#00719f",
		color: "#FFF",
		marginBottom: "0",
	},
	[`&.BANK_SUPER_ADMIN`]: {
		backgroundColor: "#0168be",
		color: "#FFF",
		marginBottom: "0",
	},
	[`&.CORPORATE_AUTHORIZER`]: {
		backgroundColor: "#27bb36",
		color: "#FFF",
		marginBottom: "0",
	},
}))

const RoleBanner = ({ role }: IRoleBannerProps) => {
	return <Banner className={role}>{role}</Banner>
}

export default RoleBanner
